import { api, APIResponse } from '@/store/api';
import type { GetInmopublicMembershipsParams, GetInmopublicMembershipsResponse } from '@/types/inmopublic-memberships.types';

export type CreateInmopublicMembershipRequest = {
  accountId: string;
  userId: string;
  role?: 'admin' | 'member' | 'viewer';
  status?: 'active' | 'inactive' | 'invited';
  invitedBy?: string;
};

export type CreateInmopublicMembershipResponse = {
  membership: {
    id: string;
    accountId: string;
    userId: string;
    role: 'admin' | 'member' | 'viewer';
    status: 'active' | 'inactive' | 'invited';
    joinedAt?: string;
    leftAt?: string;
    invitedBy?: string;
  };
};

export const inmopublicMembershipsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInmopublicMemberships: builder.query<GetInmopublicMembershipsResponse, GetInmopublicMembershipsParams>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        if (params.page) searchParams.append('page', params.page.toString());
        if (params.limit) searchParams.append('limit', params.limit.toString());
        if (params.text) searchParams.append('text', params.text);
        return {
          url: `admin-inmopublic/memberships?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: APIResponse<GetInmopublicMembershipsResponse>) => response.data,
      providesTags: ['InmopublicMemberships'],
    }),
    createInmopublicMembership: builder.mutation<CreateInmopublicMembershipResponse, CreateInmopublicMembershipRequest>({
      query: (membershipData) => ({
        url: 'admin-inmopublic/memberships',
        method: 'POST',
        body: membershipData,
      }),
      transformResponse: (response: APIResponse<CreateInmopublicMembershipResponse>) => response.data,
      invalidatesTags: ['InmopublicMemberships'],
    }),
  }),
});

export const { useGetInmopublicMembershipsQuery, useCreateInmopublicMembershipMutation } = inmopublicMembershipsApi;
